import {Card, CardActions, styled} from '@mui/material';

const StyledCard = styled(Card)`
	height: 100%;
`;

const StyledImageContainer = styled('div')`
	flex: 2;

	img {
		height: 180px;
	}

	${({theme}) => theme.breakpoints.between('sm', 'md')} {
		img {
			height: 150px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		flex: initial;

		img {
			height: 150px;
		}
	}
`;

const StyledCardActions = styled(CardActions)`
	padding-left: 11px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding-left: 8px;
	}
`;

export {StyledCard, StyledImageContainer, StyledCardActions};
